import { render, staticRenderFns } from "./AddSiteVisit.vue?vue&type=template&id=22abc20a&"
import script from "./AddSiteVisit.vue?vue&type=script&lang=js&"
export * from "./AddSiteVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports